// Site link declaration
export enum SITELINKS {
  LOGIN = "/login",
  GOOGLE_LOGIN = "/auth/google/callback",
  LINKEDIN_LOGIN = "/auth/linkedin/callback",
  REGISTER = "/register",
  REGISTER_STEP_TWO = "/register-step-two",
  REGISTER_STEP_THREE = "/register-step-three",
  HOME = "/home",
  VERIFICATION = "/verify-code",
  UPDATE_PASSWORD = "/update-password",

  ADD_PROFILE = "/add-profile",
  EDIT_PROFILE = "/update-profile",
  MY_PROFILE = "/me",
  PROFILE_VIEW = "/profile",

  ADD_INTEREST = "/add-interest",
  MAKE_REQUEST = "/make-new-request",
  MAKE_REQUEST_AUTOMATIC = "/make-new-request-automatic",

  REQUEST_REQUESTER = "/request-requester",
  MY_REQUESTS = "/my-requests",
  REQUEST_HISTORY = "/request-history",
  FORGOT_PASSWORD = "/forgot-password",
  SUBSCRIPTIONS = "/subscriptions",
  MY_RESPONSES = "/my-responses",
  MY_PAYMENTS = "/my-payments",
  PRIVATE_ACCOUNT = "/private-account",
  NOTIFICATIONS = "/notifications",
  SETTINGS = "/settings",
  CHAT = "/messaging",
  CHATIN = "/chat",
}


// Elite Links
export enum ELITELINKS {
  LOGIN = "/login",
  GOOGLE_LOGIN = "/auth/google/callback",
  LINKEDIN_LOGIN = "/auth/linkedin/callback",
  REGISTER = "/register",
  REGISTER_STEP_TWO = "/register-step-two",
  REGISTER_STEP_THREE = "/register-step-three",
  
  ELITE = "/elite-connect",
  HOME = "/elite/home",
  MAKE_REQUEST = "/elite/make-new-request",
  MY_REQUESTS = "/elite/my-requests",




  ADD_PROFILE = "/elite/add-profile",
  EDIT_PROFILE = "/elite/update-profile",
  MY_PROFILE = "/elite/me",
  PROFILE_VIEW = "/elite/profile",

  MAKE_REQUEST_AUTOMATIC = "/elite/make-new-request-automatic",

  REQUEST_REQUESTER = "/elite/request-requester",
  REQUEST_HISTORY = "/elite/request-history",
  
  SUBSCRIPTIONS = "/elite/subscriptions",
  MY_RESPONSES = "/elite/my-responses",
  MY_PAYMENTS = "/elite/my-payments",
  PRIVATE_ACCOUNT = "/elite/private-account",
  NOTIFICATIONS = "/elite/notifications",
  SETTINGS = "/elite/settings",
  CHAT = "/elite/messaging",
  CHATIN = "/elite/chat",
}